// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.indice[data-v-1e0ff814] {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 15px;\r\n  font-weight: 500;\n}\r\n", ""]);
// Exports
module.exports = exports;
